import { Modal, Text, Title } from "@mantine/core";
import React from "react";

const ViewModal = ({ modal2, setModal2, active }) => {
  return (
    <Modal opened={modal2} onClose={() => setModal2(false)} title="Movie/Series">
      <div className="grid grid-cols-2 gap-4">
        <div>
          <Title order={4}>Title</Title>
          <Text>{active?.name}</Text>
        </div>
        <div>
          <Title order={4}>Description</Title>
          <Text>{active?.description?.slice(0, 100)}</Text>
        </div>
        <div>
          <Title order={4}>Horizontal Image</Title>
          <img src={active?.horizontalBanner} alt={active?.horizontalBanner} style={{ width: 100, height: 100 }} />
        </div>
        <div>
          <Title order={4}>Vertical Image</Title>
          <img src={active?.verticalBanner} alt={active?.verticalBanner} style={{ width: 100, height: 100 }} />
        </div>
      </div>
    </Modal>
  );
};

export default ViewModal;
